module.exports = __webpack_public_path__ + "Roboto-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Regular.woff
// module id = 98
// module chunks = 0